import React from 'react';
import './styles.less';
import PropTypes from 'prop-types';
import { ModalActionButtons } from '../../../../semantic-ui/components/modal-window/modal-action-buttons';

const ModalHeader = ({ onAddButtonClick, onModalClose, title }) => {
	return (
		<div className="modal-header">
			<div className="modal-header__actions">
				<div className="modal-header__buttons">
					{onAddButtonClick && <div className="modal-header__header-button" onClick={onAddButtonClick} />}
					{title}
				</div>
			</div>
			<div className="modal-header__close-button">
				<ModalActionButtons buttons={[{ type: 'close', onClick: onModalClose, text: 'forgot' }]} />
			</div>
		</div>
	);
};

ModalHeader.propTypes = {
	onAddButtonClick: PropTypes.func,
	onModalClose: PropTypes.func.isRequired,
	title: PropTypes.string,
};

export { ModalHeader };
